<ul [class]="containerClass">
    @for (tab of tabs(); track tab.id) {
        <li [class]="tabClass(tab)" [attr.data-menu-item-id]="tab.id" (click)="selected($event, tab)">
            <a (click)="$event.preventDefault()">
                @if (tab.icon) {
                    <vn-icon size="18" [name]="tab.icon" />
                }

                @if (tab.title && tabFormatted(tab.title)) {
                    <span class="title" [innerHTML]="tab.title"></span>
                } @else {
                    <span class="title">{{ tab.title }}</span>
                }
            </a>
        </li>
    }
</ul>
